import React, { useState } from "react";

import VideoModal from "../video-modal/VideoModal";

const FitemWrapper = ({ DlUrl, imgURL, name, isHosted, hostedPath, sku }) => {
  const [modal, setModal] = useState(false); // Controls the modal show/hide functionality with a simple boolean.
  const [itemSku, setItemSku] = useState(sku);
  const [videoType, setVideoType] = useState("");
  const [downloadUrl, setDownloadUrl] = useState(DlUrl);
  const [hostedVideo, setHostedVideo] = useState(isHosted);
  const [hostedVideoDocPath, setHostedVideoDocPath] = useState(hostedPath);
  const [thumnnailImg, setThumbnailImg] = useState(imgURL);

  // this runs on the close button on the modal. We have to set modalFitem to ('') or else the video will keep playing when you close the modal.
  function renderClose() {
    setModal(false);
    setItemSku("");
    setDownloadUrl("");
    setHostedVideo("");
    setHostedVideoDocPath("");
    setThumbnailImg("");
  }
  const prUrl = process.env.REACT_APP_PUBLICRATES_URL;
  const imgLink = `${prUrl}${imgURL}`;
  // console.log(DlUrl);
  return (
    <div style={{ maxWidth: "290px" }}>
      <img
        onClick={() => {
          setItemSku(sku);
          setDownloadUrl(DlUrl);
          setHostedVideo(isHosted);
          setHostedVideoDocPath(hostedPath);
          setThumbnailImg(imgURL);
          setModal(true);
        }}
        src={imgLink}
        alt="fitem thumbnail"
        style={{ width: "100%" }}
        className="pointer"
      />
      <VideoModal
        show={modal}
        close={renderClose}
        sku={itemSku}
        notHostedLink={downloadUrl}
        isHosted={hostedVideo}
        hostedPath={hostedVideoDocPath}
        thumbnailImg={thumnnailImg}
        isVideo={hostedVideo}
      />
    </div>
  );
};

export default FitemWrapper;
